import { render, staticRenderFns } from "./CountTabs.vue?vue&type=template&id=4c07cfbf&scoped=true&lang=pug&"
import script from "./CountTabs.vue?vue&type=script&lang=js&"
export * from "./CountTabs.vue?vue&type=script&lang=js&"
import style0 from "./CountTabs.vue?vue&type=style&index=0&id=4c07cfbf&lang=scss&scoped=true&"
import style1 from "./CountTabs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07cfbf",
  null
  
)

export default component.exports